import PurchasesDashboard from "../../components/PurchasesDashboard";

export default function PurchasesPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Gas Purchases</h1>
      <PurchasesDashboard timeRange="month" />
    </div>
  );
}